import React, { Component } from 'react'
import './App.css'

export default class App extends Component {
  render() {
    return (
      <div className='app'>
        <div className='card'>

          <div className='logo'>
            <div className='logo-dot'></div>
            Notify Me
          </div>

          <div className='icon-box'>
            <span role="img" aria-label="bell">🔔</span>
          </div>

          <h1>Get Intercom CSATs in Slack</h1>
          <p className='subtitle'>Real-time notifications and weekly reports — straight to your Slack channel.</p>

          <div className='badge'>
            <a href="https://www.intercom.com/app-store" target="_blank" rel="noopener noreferrer">
              <img
                src="https://i.ibb.co/Pwgg0C0/609a3f955e25e3e3b2b67581-Certified-Saasy-People.png"
                alt="Certified Intercom Partner"
                style={{height: '40px', width: 'auto'}}
              />
            </a>
          </div>

          <div className='features'>
            <div className='feature'><span role="img" aria-label="lightning">⚡</span> Instant CSAT alerts</div>
            <div className='feature'><span role="img" aria-label="chart">📊</span> Weekly reports</div>
            <div className='feature'><span role="img" aria-label="lock">🔒</span> Secure OAuth2</div>
          </div>

          <a href='/.netlify/functions/auth' className='btn'>
            <img
              alt='Connect with Intercom'
              src='https://static.intercomassets.com/assets/oauth/primary-7edb2ebce84c088063f4b86049747c3a.png'
              srcSet='https://static.intercomassets.com/assets/oauth/primary-7edb2ebce84c088063f4b86049747c3a.png 1x, https://static.intercomassets.com/assets/oauth/primary@2x-0d69ca2141dfdfa0535634610be80994.png 2x'
              style={{height: '44px', width: 'auto'}}
            />
          </a>

          <p className='terms'>
            By signing up you agree to our{' '}
            <a href='https://notifymeintercom.netlify.app/terms-of-service'>Terms</a>{' '}
            and{' '}
            <a href='https://notifymeintercom.netlify.app/privacy-policy'>Privacy Policy</a>.
            Need help?{' '}
            <a href='mailto:SupportLoveApp@Proton.me'>Contact us</a>
          </p>

        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/App.js